import React from 'react';
import Component from '@vfuk/core-heading';
const Heading = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Heading;
